import gql from 'graphql-tag';
import format from 'date-fns/format';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';

export const periodFields = `
  id
  name
  dateFrom  
  dateTo
  type
  description
  wab {
    id
    filename
  }
`;

const dateFormat = 'yyyy-MM-dd';
const dateNow = new Date();
const weekStart = format(startOfWeek(dateNow), dateFormat);
const weekEnd = format(endOfWeek(dateNow), dateFormat);
console.log('START: ', weekStart);
console.log('END: ', weekEnd);

const key = `ListCurrentPeriod`;
const query = gql`
query ${key}($from:String="${weekStart}", $to:String="${weekEnd}") {
  listPeriods(filter:{and:{
    dateFrom:{eq:$from},
    dateTo:{eq:$to}
    }
  }) {
    items{
      ${periodFields}
    }
  }
}
`;

export const LIST_CURRENT_PERIOD = { key, query };
